import { connect } from "react-redux";
import { pick } from "ramda";
import { refreshView as refreshViewAction } from "ra-core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import React from "react";
import ReactFileReader from "react-file-reader";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import ExampleRoom from "../../statics/ExampleRoom.csv";

import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  CardActions,
  CreateButton,
  RefreshButton,
  ReferenceField,
  Filter,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ChipField,
  ExportButton
} from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { HOST } from "../../configs/index";
import uploadService from "../../services/uploadService";
import { SUPERADMIN } from "../../constant/TypeRole";

const RoomFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="name_contains" />
      <TextInput source="type_contains" />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

const funcExporter = (records, fetchRelatedRecords) => {
	Promise.all(records.map(async (record) => {
		let newRecord = {
      name: record.name,
      type: record.type
    };
    const paramsUsers = record.users.map(user => user.id).join("&_id=")
		await fetchRelatedRecords(records, "project", "project").then(res => { newRecord = { ...newRecord, project: res[record.project] ? res[record.project].name : "" }; });		
    const token = localStorage.getItem("token");
    if (paramsUsers) {
      const users = await fetch(`${HOST}/user?_id=${paramsUsers}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      const responseJson = await users.json();
      if (responseJson && responseJson.length > 0)
      	newRecord = { ...newRecord, users: responseJson.map(u => u.email).toString() };
      else newRecord = { ...newRecord, users: "" };
    } 
		return {
			...newRecord,
		};
	})).then(data => {
		const csv = convertToCSV({
			data,
			fields: ["name", "type", "project", "users"] 
		});
		csvDownload(csv, "rooms");
	});
};

const csvDownload = (csv, filename) => {
	const fakeLink = document.createElement("a");
	fakeLink.style.display = "none";
	document.body.appendChild(fakeLink);
	const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `${filename}.csv`);
	} else {
		fakeLink.setAttribute("href", URL.createObjectURL(blob));
		fakeLink.setAttribute("download", `${filename}.csv`);
		fakeLink.click();
	}
};

export const RoomList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="room.room"
      bulkActions={false}
      filters={<RoomFilter />}
      filterDefaultValues={filter}
      exporter={funcExporter}
      actions={<RoomActions />}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <TextField source="type" />
        <ReferenceField source="project" reference="project" linkType={false}>
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};

const mapStateToProps = state => ({
  allProject: state.admin.resources.project.data
});
const enhance = connect(
  mapStateToProps,
  { refreshView: refreshViewAction }
);
const RoomActions = enhance(
  class RoomActions extends React.Component {
    state = {
      loading: false,
      open: false,
      files: null,
      project: ""
    };
    handleOpen = () => this.setState({ open: true });
    handleClose = () =>
      this.setState({ open: false, project: "", files: null });
    setLoading = (loading = false) => this.setState({ loading });
    render() {
      const { loading, files, project } = this.state;
      const {
        resource,
        filters,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        allProject,
        total,
        currentSort,
        exporter
      } = this.props;
      const role = localStorage.getItem("role");
      const myProject = JSON.parse(localStorage.getItem("project"));
      const pickProject =
        role === SUPERADMIN ? allProject : pick(myProject, allProject);
      return (
        <CardActions>
          {filters &&
            React.cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: "button"
            })}
          <CreateButton basePath={basePath} />
          <RefreshButton />
          <ExportButton
            disabled={total === 0}
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
          />
          <Button
            onClick={this.handleOpen}
            primary="true"
            style={{ color: "#3f51b5" }}
          >
            Import Room CSV
          </Button>

          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.open}
          >
            <div
              style={{
                position: "relative",
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "4px",
                width: "70%",
                margin: "0 auto",
                minHeight: "300px",
                top: "20%"
              }}
            >
              <Typography variant="title" id="modal-title">
                Import room by CSV
              </Typography>
              <Typography variant="subheading" id="simple-modal-description" />
              <div style={{ marginTop: 20 }}>
                <a href={ExampleRoom}>Download Example Room</a>
              </div>
              <FormControl required style={{ width: 300, marginTop: 20 }}>
                <InputLabel htmlFor="age-simple">Project</InputLabel>
                <Select
                  value={this.state.project}
                  onChange={({ target: { value } }) =>
                    this.setState({ project: value })
                  }
                  input={<Input id="project-simple" />}
                >
                  {Object.keys(pickProject).map(key => (
                    <MenuItem key={key} value={key}>
                      {pickProject[key].name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>Required</FormHelperText>
              </FormControl>
              <div style={{ marginTop: 30 }}>
                <ReactFileReader
                  fileTypes={[".csv"]}
                  handleFiles={files => this.setState({ files })}
                >
                  <Button variant="raised" component="span">
                    Choose file
                  </Button>
                  {files &&
                    files[0] &&
                    files[0].name && (
                      <span style={{ marginLeft: 10 }}>{files[0].name}</span>
                    )}
                </ReactFileReader>
              </div>
              <div style={{ position: "absolute", bottom: 20, right: 30 }}>
                <Button
                  primary="true"
                  style={{ color: "red" }}
                  onClick={this.handleClose}
                >
                  Cancel
                </Button>
                <Button
                  primary="true"
                  style={{ color: "#3f51b5" }}
                  onClick={() =>
                    project && files
                      ? importRoom(
                        files,
                        project,
                        this.setLoading,
                        this.props.refreshView,
                        this.handleClose
                      )
                      : alert("Please select Project & CSV file")
                  }
                >
                  UPLOAD
                </Button>
              </div>
            </div>
          </Modal>
          <Loading open={loading} />
        </CardActions>
      );
    }
  }
);

const Loading = ({ ...other }) => (
  <Dialog {...other}>
    <DialogTitle id="simple-dialog-title">Loading...</DialogTitle>
    <div style={{ textAlign: "center", marginBottom: 20, height: 50 }}>
      <CircularProgress />
    </div>
  </Dialog>
);

const importRoom = (files, project, setLoading, refreshView, closeModal) => {
  setLoading(true);
  uploadService([{ rawFile: files[0] }]).then(res => {
    const token = localStorage.getItem("token");
    const fecthOption = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    const formData = new FormData();
    formData.append("csv", res.url);
    formData.append("project", project);
    fecthOption.body = formData;
    fetch(`${HOST}/room`, fecthOption)
      .then(response => response.json())
      .then(responseJson => {
        setLoading(false);
        closeModal();
        setTimeout(() => refreshView(), 1000);
        alert(`Success ${responseJson ? responseJson.length || 0 : 0} rows`);
      })
      .catch(error => {
        setLoading(false);
        alert("Error");
      });
  });
};



// WEBPACK FOOTER //
// ./src/components/room/RoomList.js